/*
 * @Author: Michael 
 * @Date: 2018-09-19 19:17:47 
 * @Last Modified by: wufan
 * @Last Modified time: 2020-08-25 14:22:47
 */

import Vue, { VueConstructor } from 'vue';
import ConfirmComp from './Confirm.vue';

import store from '@/store';


interface InstanceState {
  $el: any,
  closed: boolean,
  close: Function,
  visible: boolean,
  ok: Function,
  cancle: Function,
  classname: string,
  title: string,
  text: string,
  oneBtn: boolean,
  cancelType:boolean,
  okText: string,
  cancleText: string,
  mainTextColor: string,
  closeBtn:boolean
}

const instancePool: Array<VueConstructor> = []; // 实例池
const ConfirmConstructor = Vue.extend(ConfirmComp);

const getAnInstance = () => {
  if (instancePool.length > 0) {
    const instance = instancePool.shift();
    return instance;
  }
  return new ConfirmConstructor({
    el: document.createElement('div')
  })
}

const removeDom = (event: Event) => {
  if ((event.target as any).parentNode) {
    (event.target as any).parentNode.removeChild(event.target);
  }
}

ConfirmConstructor.prototype.close = function () {
  this.visible = false;
  this.$el.addEventListener('transitionend', removeDom);
  this.closed = true;
  instancePool.push(this);
}
/**
 *
 *
 * @param {*} [options={
 * ok 确定的回调函数
 * cancle 取消的回调函数
 * okText
 * cancleText
 * title
 * content  <html>
 * oneBtn  <boolean>
 * className
 * }]
 */
const Confirm = (options: InstanceState) => {
  let instance = <InstanceState>getAnInstance();
  instance.closed = false;
  const { ok, cancle, classname, title, text, oneBtn,cancelType,closeBtn, okText, cancleText } = options;

  instance.ok = function () {
    if (options.ok) {
      options.ok();
    }
    instance.close();
  };
  instance.cancle = function () {
    if (options.cancle) {
      options.cancle();
    }
    instance.close();
  };
  instance.mainTextColor = store.getters.mainTextColor;
  instance.classname = classname || '';
  instance.title = title || '提示';
  instance.text = text || '确定保存吗？';
  instance.oneBtn = oneBtn || false
  instance.cancelType = cancelType || false;
  instance.closeBtn = closeBtn || false;
  instance.okText = okText || '确定';
  instance.cancleText = cancleText || '取消';

  (document.querySelector('.mask-layer') as HTMLElement).appendChild(instance.$el);

  Vue.nextTick(() => {
    instance.visible = true;
    instance.$el.removeEventListener('transitionend', removeDom);
  });

  return instance;
}

export default Confirm;